export const HorizontalLine = (props) => {
  return (
    <div className="flex justify-center my-5">
      <span
        className="h-[2px] bg-[#b99470] z-[1] flex justify-center "
        style={{ width: `${props.width}px` }}
      ></span>
    </div>
  );
};
